import { Box, Paper, keyframes, Typography, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';

const blink = keyframes`
  0% { opacity: 0.2; }
  20% { opacity: 1; }
  100% { opacity: 0.2; }
`;

const TypingIndicator = () => {
  const [messageIndex, setMessageIndex] = useState(0);
  const theme = useTheme();

  const messages = [
    'Reading your Vedic chart ',
    'Kaliyug is thinking ',
    "It'll take a few seconds ",
  ];

  useEffect(() => {
    const timer1 = setTimeout(() => setMessageIndex(1), 5000); // Switch to 2nd message after 5 seconds
    const timer2 = setTimeout(() => setMessageIndex(2), 10000); // Switch to 3rd message after 10 seconds

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        mt: 2,
        borderRadius: '12px',
        bgcolor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        gap: '4px',
      }}
    >
      <Typography variant="body1">{messages[messageIndex]}</Typography>
      <Box sx={{ display: 'flex', gap: '4px', ml: 0.5 }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 6,
              height: 6,
              mt: 1,
              borderRadius: '50%',
              bgcolor: 'text.secondary',
              animation: `${blink} 1.4s infinite both`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default TypingIndicator;
